import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {TableIcon} from '@primer/octicons-react'

import {LABELS} from '../constants/labels'
import type {ProjectV2ItemStatusChangedEventNode} from './issue-viewer-view-query-types'
import {ProjectV2} from './ProjectV2'
import styles from './ProjectV2ItemStatusChangedEvent.module.css'
import {TimelineRow} from './row/TimelineRow'

// RELAY-CLEANUP(ProjectV2ItemStatusChangedEvent): widens nullable fields so still-Relay parent data is assignable.
// Remove when IssueTimelineItem leaves Relay.
export type ProjectV2ItemStatusChangedEventFragment = RelayCompat<
  Pick<ProjectV2ItemStatusChangedEventNode, 'actor' | 'createdAt' | 'previousStatus' | 'project' | 'status'>
>

type ProjectV2ItemStatusChangedEventProps = {
  queryRef: ProjectV2ItemStatusChangedEventFragment
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
}

export function ProjectV2ItemStatusChangedEvent({
  queryRef,
  issueUrl,
  onLinkClick,
}: ProjectV2ItemStatusChangedEventProps): React.ReactElement {
  const {actor, createdAt, project, previousStatus, status} = queryRef

  if (!project) {
    return <></>
  }

  const safeStatus = status.length > 0 ? status : 'No status'

  // Once we have support for the project IDs being exposed in GQL we can shift to using the
  // `issueEventExternalUrl` function here for our deep linked timestamp.
  return (
    <TimelineRow
      highlighted={false}
      actor={actor}
      onLinkClick={onLinkClick}
      createdAt={createdAt}
      deepLinkUrl={issueUrl}
      leadingIcon={TableIcon}
    >
      <TimelineRow.Main>
        {previousStatus && previousStatus.length > 0 ? (
          <>{`${LABELS.timeline.movedThisFrom} ${previousStatus} ${LABELS.timeline.to} `}</>
        ) : (
          <>{`${LABELS.timeline.movedThisTo} `}</>
        )}
        {`${safeStatus} ${LABELS.timeline.in} `}
        <span className={styles.projectWrapper}>
          <ProjectV2 title={project?.title} url={project?.url} />
        </span>
      </TimelineRow.Main>
    </TimelineRow>
  )
}
